// extracted by mini-css-extract-plugin
export var burgerWrapper = "header-module--burgerWrapper--1ef51";
export var icons = "header-module--icons--4c2fb";
export var menuIcon = "header-module--menuIcon--57835";
export var menuIcons = "header-module--menuIcons--d2073";
export var wrapper = "header-module--wrapper--5cdb2";